export default "__VITE_ASSET__BmmmHoa1__"